import { render, staticRenderFns } from "./TableDraftsMail.vue?vue&type=template&id=6c502ede&scoped=true&"
import script from "./TableDraftsMail.vue?vue&type=script&lang=js&"
export * from "./TableDraftsMail.vue?vue&type=script&lang=js&"
import style0 from "./TableDraftsMail.vue?vue&type=style&index=0&id=6c502ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c502ede",
  null
  
)

export default component.exports